import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import css from './styles.module.scss';

interface UserRoleProps {
    role: string;
    className?: string;
}

export const UserRoleBadge: React.FC<UserRoleProps> = ({ role, className }) => {
    return <Typography className={classNames(css.module, className)}>{role}</Typography>;
};
